import Status from '@/constants/Status';

class UserInfoModel {
  status?: Status

  nickName?: string

  accessGroup?: string

  remark?: string

  phoneNo?: string

  creationDate?: Date

  userAccount?: string
}

export default UserInfoModel;
